import {DuplicateGmcFormValues, GmcFormValues} from '@common/types/forms/productForms.types';
import {ProductSections} from '@common/types/stores/productSheetStore.types';

export const mapGmcValuesForCreate = (values: GmcFormValues) => ({
  launchYear: values.launchYear,
  idppm: values.idppm || undefined,
  reasonOfLaunch: values.reasonOfLaunch || undefined,
  subVersionLabel: values.subVersionLabel || undefined
});

export const mapGmcValuesForDuplicate = (values: GmcFormValues, sections: ProductSections, uncheckedItems: Array<string | number>): DuplicateGmcFormValues => {
  const {branding, feedingGuides, otherLegalElements, packagingFeatures, productFeatures} = sections;

  const result: DuplicateGmcFormValues = {
    launchYear: values.launchYear,
    idppm: values.idppm || undefined,
    reasonOfLaunch: values.reasonOfLaunch || undefined,
    subVersionLabel: values.subVersionLabel || undefined
  };

  if (branding) {
    result.brandTexts = branding.brandTexts?.map(({id}: {id: string}) => id).filter((id: string) => !uncheckedItems.includes(id));
    result.rangeTexts = branding.rangeTexts?.map(({id}: {id: string}) => id).filter((id: string) => !uncheckedItems.includes(id));
  }

  if (feedingGuides) {
    result.feedingGuideTexts = feedingGuides.feedingGuideTexts?.map(({id}: {id: string}) => id).filter((id: string) => !uncheckedItems.includes(id));
  }

  if (productFeatures) {
    if (productFeatures.commercialLabel && !uncheckedItems.includes(productFeatures.commercialLabel?.id)) {
      result.commercialLabel = productFeatures.commercialLabel?.id;
    }

    if (productFeatures.legalTextSubHeading && !uncheckedItems.includes(productFeatures.legalTextSubHeading?.id)) {
      result.legalTextSubHeading = productFeatures.legalTextSubHeading?.id;
    }

    result.productBenefitsIntentions = productFeatures.productBenefitsIntentions
      ?.filter(({id}: {id: string}) => !uncheckedItems.includes(id))
      ?.map(({id}: {id: string}, index: number) => ({id, sorting: index + 1}));

    result.sensitivitiesIntentions = productFeatures.sensitivitiesIntentions
      ?.filter(({id}: {id: string}) => !uncheckedItems.includes(id))
      ?.map(({id}: {id: string}, index: number) => ({id, sorting: index + 1}));

    result.formulaFeaturesIntentions = productFeatures.formulaFeaturesIntentions
      ?.filter(({id}: {id: string}) => !uncheckedItems.includes(id))
      ?.map(({id}: {id: string}, index: number) => ({id, sorting: index + 1}));

    result.graphicalElementsTextsIntentions = productFeatures.graphicalElementsTextsIntentions
      ?.filter(({id}: {id: string}) => !uncheckedItems.includes(id))
      ?.map(({id}: {id: string}, index: number) => ({id, sorting: index + 1}));
  }

  if (packagingFeatures) {
    result.packagingFeatures = packagingFeatures.packagingFeatures?.map(({id}: {id: string}) => id).filter((id: string) => !uncheckedItems.includes(id));
  }

  if (otherLegalElements) {
    result.otherLegalElements = otherLegalElements.otherLegalElements?.map(({id}: {id: string}) => id).filter((id: string) => !uncheckedItems.includes(id));
  }

  return result;
};
